import businesses from './businesses.json'
import companies from './companies.json'
import contacts from './contacts.json'
import contacts_csv from './contacts_csv.json'
import contacts_group from './contacts_group.json'
import error_messages from './error_messages.json'
import flows from './flows.json'
import general from './general.json'
import groups from './groups.json'
import integrations from './integrations.json'
import recipient from './recipient.json'
import template from './template.json'
import users from './users.json'
import voip from './voip.json'

module.exports = {
    businesses,
    companies,
    contacts,
    contacts_csv,
    contacts_group,
    error_messages,
    flows,
    general,
    groups,
    integrations,
    template,
    recipient,
    users,
    voip
}



// WEBPACK FOOTER //
// ./src/locales/en_us/i18n/index.js